declare var require: any;

export module GlobalConstants{
    
    //ETSAPI
    export const API_URL:string = 'https://app-aeroveraiq-api-dev-eus.azurewebsites.net/api/'; 
    export const API_URLs:string = 'https://app-enose-prd-eus-api.azurewebsites.net/'; 
    // export const API_URL:string = 'http://localhost:5176/'; 
    // export const API_URL:string = 'https://fastbrassski98.conveyor.cloud/api/';

    export const PrivacyPolicyURL: string = 'https://stgenoseprdeus.blob.core.windows.net/simplifi-public-docs/Simpli-Fi%20Privacy%20Policy.pdf';

    export const FUNCTION_APP_URL: string = 'https://fa-enose-dev-eus-fphvcuf9d9fwg9fh.eastus-01.azurewebsites.net/api/';
    //  export const FUNCTION_APP_URL: string = 'https://lastgreenpencil18.conveyor.cloud/api/';
     


     export const Function_APP_KEY: string = '2mt_7bGN4psgey4R4XrTz6Oq8en340l6t3x79EBL5xgpAzFuY-xSkQ==';

    // Control Hub FE base URL (DEV)
    export const CONTROL_HUB_URL: string = 'https://app-controlhub-fe-dev-eus.azurewebsites.net';

    // export const SignalR_API_URL: string = 'https://app-controlhub-api-dev-eus.azurewebsites.net/NotificationHubSocket';
}